import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastrNotificationService } from '../../Common/toastr-notification.service';
import { Evoryn } from '../../Servcie/evoryn';

@Component({
  selector: 'app-singup',
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './singup.html',
  styleUrl: './singup.css',
})
export class Singup implements OnInit {

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.closeDropdowns();
  }


  SignupForm!: FormGroup;
  countries: any[] = [];
  states: any[] = [];
  cities: any[] = [];
  pincodes: any[] = [];
  areas: any[] = [];

  isExistingUser: boolean = false;
  userData: any = null;
  phone: string = '';

  constructor(
    private fb: FormBuilder,
    private service: Evoryn,
    private toast: ToastrNotificationService,
    private router: Router
  ) {
    this.SignupForm = this.fb.group({
      userID: [0],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [{value: '', disabled: true}],
      address: ['', Validators.required],
      countryID: [0, [Validators.required, Validators.min(1)]],
      stateID: [0, [Validators.required, Validators.min(1)]],
      cityID: [0, [Validators.required, Validators.min(1)]],
      pincodeID: [0, [Validators.required, Validators.min(1)]],
      areaID: [0, [Validators.required, Validators.min(1)]],
      instagram: [''],
      telegram: [''],
      whatsapp: [''],
      facebook: [''],
      description: [''],
      isTermsAgreed: [false, Validators.requiredTrue]
    });

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.isExistingUser = navigation.extras.state['isExistingUser'];
      if (this.isExistingUser) {
        this.userData = navigation.extras.state['userData'];
        this.phone = this.userData?.phoneNumber || '';
      } else {
        this.phone = navigation.extras.state['phone'] || '';
      }
    }
    if (!this.phone) {
      this.phone = sessionStorage.getItem('phoneNumber') || '';
    }
    this.SignupForm.patchValue({ phoneNumber: this.phone });
  }

  ngOnInit(): void {
    this.getCountries();
    if (this.userData) {
      this.bindUserData();
    }
  }

  bindUserData() {
    this.SignupForm.patchValue({
      firstName: this.userData.firstName,
      lastName: this.userData.lastName,
      email: this.userData.email,
      isTermsAgreed: true
    });

    if (this.userData.address) {
      const address = this.userData.address;
      this.SignupForm.patchValue({
        address: address.address,
        countryID: address.countryID
      });

      if (address.countryID > 0) {
        this.service.getallstate(address.countryID).subscribe((res: any) => {
          if (res.status) {
            this.states = res.data;
            this.filteredStates = [...this.states];
            this.SignupForm.patchValue({ stateID: address.stateID });
            
            if (address.stateID > 0) {
              this.service.getallcity(address.stateID).subscribe((res: any) => {
                if (res.status) {
                  this.cities = res.data;
                  this.filteredCities = [...this.cities];
                  this.SignupForm.patchValue({ cityID: address.cityID });
                  
                  if (address.cityID > 0) {
                    this.service.getallpincode(address.cityID).subscribe((res: any) => {
                      if (res.status) {
                        this.pincodes = res.data;
                        this.filteredPincodes = [...this.pincodes];
                        this.SignupForm.patchValue({ pincodeID: address.pincodeID });

                        if (address.pincodeID > 0) {
                          this.service.getallarea(address.pincodeID).subscribe((res: any) => {
                            if (res.status) {
                              this.areas = res.data;
                              this.filteredAreas = [...this.areas];
                              this.SignupForm.patchValue({ areaID: address.areaID });
                            }
                          });
                        }
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    }
  }

  getCountryName(id: number): string {
    if (!id) return 'Select Country';
    const c = this.countries.find(x => (x.countryID || x.countryId) == id);
    return c ? c.countryName : 'Select Country';
  }

  getStateName(id: number): string {
    if (!id) return 'Select State';
    const s = this.states.find(x => (x.stateID || x.stateId) == id);
    return s ? s.stateName : 'Select State';
  }

  getCityName(id: number): string {
    if (!id) return 'Select City';
    const c = this.cities.find(x => (x.cityID || x.cityId) == id);
    return c ? c.cityName : 'Select City';
  }

  getPincodeName(id: number): string {
    if (!id) return 'Select Pincode';
    const p = this.pincodes.find(x => (x.pincodeID || x.pincodeId) == id);
    return p ? p.pincode : 'Select Pincode';
  }

  getAreaName(id: number): string {
    if (!id) return 'Select Area';
    const a = this.areas.find(x => (x.areaID || x.areaId) == id);
    return a ? a.areaName : 'Select Area';
  }

  getCountries() {
    this.service.getallcountry().subscribe((res: any) => {
      if (res.status) {
        this.countries = res.data;
        this.filteredCountries = [...this.countries];
      }
    });
  }

  activeDropdown: string = '';
  filteredCountries: any[] = [];
  filteredStates: any[] = [];
  filteredCities: any[] = [];
  filteredPincodes: any[] = [];
  filteredAreas: any[] = [];

  toggleDropdown(dropdown: string, event: Event) {
    event.stopPropagation();
    this.activeDropdown = this.activeDropdown === dropdown ? '' : dropdown;
    if (this.activeDropdown === 'country') this.filteredCountries = [...this.countries];
    if (this.activeDropdown === 'state') this.filteredStates = [...this.states];
    if (this.activeDropdown === 'city') this.filteredCities = [...this.cities];
    if (this.activeDropdown === 'pincode') this.filteredPincodes = [...this.pincodes];
    if (this.activeDropdown === 'area') this.filteredAreas = [...this.areas];
  }

  closeDropdowns() {
    this.activeDropdown = '';
  }

  filterList(type: string, event: any) {
    const term = event.target.value.toLowerCase();
    if (type === 'country') this.filteredCountries = this.countries.filter(c => c.countryName.toLowerCase().includes(term));
    if (type === 'state') this.filteredStates = this.states.filter(s => s.stateName.toLowerCase().includes(term));
    if (type === 'city') this.filteredCities = this.cities.filter(c => c.cityName.toLowerCase().includes(term));
    if (type === 'pincode') this.filteredPincodes = this.pincodes.filter(p => p.pincode.toLowerCase().includes(term));
    if (type === 'area') this.filteredAreas = this.areas.filter(a => a.areaName.toLowerCase().includes(term));
  }

  selectCountry(item: any) {
    this.SignupForm.patchValue({ countryID: item.countryID || item.countryId });
    this.activeDropdown = '';
    this.onCountryChange();
  }

  onCountryChange() {
    const id = Number(this.SignupForm.value.countryID);
    this.states = [];
    this.filteredStates = [];
    this.cities = [];
    this.pincodes = [];
    this.areas = [];
    this.SignupForm.patchValue({ stateID: 0, cityID: 0, pincodeID: 0, areaID: 0 });

    if (id > 0) {
      this.service.getallstate(id).subscribe((res: any) => {
        if (res.status) {
          this.states = res.data;
          this.filteredStates = [...this.states];
        }
      });
    }
  }

  selectState(item: any) {
    this.SignupForm.patchValue({ stateID: item.stateID || item.stateId });
    this.activeDropdown = '';
    this.onStateChange();
  }

  onStateChange() {
    const id = Number(this.SignupForm.value.stateID);
    this.cities = [];
    this.filteredCities = [];
    this.pincodes = [];
    this.areas = [];
    this.SignupForm.patchValue({ cityID: 0, pincodeID: 0, areaID: 0 });

    if (id > 0) {
      this.service.getallcity(id).subscribe((res: any) => {
        if (res.status) {
          this.cities = res.data;
          this.filteredCities = [...this.cities];
        }
      });
    }
  }

  selectCity(item: any) {
    this.SignupForm.patchValue({ cityID: item.cityID || item.cityId });
    this.activeDropdown = '';
    this.onCityChange();
  }

  onCityChange() {
    const id = Number(this.SignupForm.value.cityID);
    this.pincodes = [];
    this.filteredPincodes = [];
    this.areas = [];
    this.SignupForm.patchValue({ pincodeID: 0, areaID: 0 });

    if (id > 0) {
      this.service.getallpincode(id).subscribe((res: any) => {
        if (res.status) {
          this.pincodes = res.data;
          this.filteredPincodes = [...this.pincodes];
        }
      });
    }
  }

  selectPincode(item: any) {
    this.SignupForm.patchValue({ pincodeID: item.pincodeID || item.pincodeId });
    this.activeDropdown = '';
    this.onPincodeChange();
  }

  onPincodeChange() {
    const id = Number(this.SignupForm.value.pincodeID);
    this.areas = [];
    this.filteredAreas = [];
    this.SignupForm.patchValue({ areaID: 0 });

    if (id > 0) {
      this.service.getallarea(id).subscribe((res: any) => {
        if (res.status) {
          this.areas = res.data;
          this.filteredAreas = [...this.areas];
        }
      });
    }
  }

  selectArea(item: any) {
    this.SignupForm.patchValue({ areaID: item.areaID || item.areaId });
    this.activeDropdown = '';
  }

  onSubmit() {
    if (this.SignupForm.invalid) {
      this.SignupForm.markAllAsTouched();
      this.toast.showError('Please fill in all required fields and ensure terms are checked.');
      return;
    }

    const payload = {
      userID: this.SignupForm.value.userID,
      firstName: this.SignupForm.value.firstName,
      lastName: this.SignupForm.value.lastName,
      email: this.SignupForm.value.email,
      phoneNumber: this.phone,
      whatsApp: this.SignupForm.value.whatsapp,
      instagram: this.SignupForm.value.instagram,
      faceBook: this.SignupForm.value.facebook,
      telegram: this.SignupForm.value.telegram,
      description: this.SignupForm.value.description,
      isTermsAgreed: this.SignupForm.value.isTermsAgreed,
      userAddressID: (this.userData && this.userData.address) ? this.userData.address.userAddressID : 0,
      countryID: Number(this.SignupForm.value.countryID),
      stateID: Number(this.SignupForm.value.stateID),
      cityID: Number(this.SignupForm.value.cityID),
      pincodeID: Number(this.SignupForm.value.pincodeID),
      areaID: Number(this.SignupForm.value.areaID),
      address: this.SignupForm.value.address,
      addressType: 0,
      latitude: 0,
      longitude: 0,
      mapURL: ''
    };

    console.log('Associative Signup Payload:', payload);
    this.service.partnersignup(payload).subscribe(
      (resp: any) => {
        if (resp.status) {
          this.toast.showSuccess(resp.message || 'Signup request submitted successfully!');
          setTimeout(() => {
            this.router.navigate(['/bank-detail']);
          }, 1000);
        } else {
          this.toast.showError(resp.message || 'Error submitting request');
        }
      },
      (error) => {
        this.toast.showError('Something went wrong. Please try again.');
      }
    );
  }
}
